import { type FC, type ReactElement, startTransition, useLayoutEffect } from "react"

import { useTranslation } from "react-i18next"
import { type NavigateFunction, useNavigate } from "react-router-dom"

import { EPath } from "@/3514/constants"
import { type TScreenBreakpoints, type TUserState, useScreenBreakpoints, useUser } from "@/3514/hooks"
import { EUserRole } from "@/3514/types"
import { SimulabHeader } from "@/entities/simulab"
import { SimulabCoacheeList } from "@/features/simulab-coachees"
import { ParticipantLayout } from "@/layouts"
import CareTeamLink from "@/shared/CareTeamLink"

import "./styles.scss"

export const SimulabCoachees: FC = (): ReactElement => {
    const { user }: TUserState<EUserRole.Participant> = useUser<EUserRole.Participant>()

    const breakpoints: TScreenBreakpoints = useScreenBreakpoints()

    const isMobile: boolean = breakpoints.sm || breakpoints.xs

    const { t } = useTranslation()

    const navigate: NavigateFunction = useNavigate()

    useLayoutEffect(
        (): void => (
            !user.isPracticeLabAvailable && startTransition((): void => void navigate(EPath.Participant_Dashboard())),
            void 0
        ),
        [user, navigate]
    )

    return (
        <ParticipantLayout
            className="practice-lab-layout"
            noPadding
            showLogoOnMobile={false}
            closeMenu
            title={!isMobile && <SimulabHeader />}
            header={isMobile && <SimulabHeader />}
        >
            <section className="practice-lab-coachee !pb-[40px] md:!pb-[100px]">
                <p className="practice-lab-coachee__text">
                    {t("Who would you like to practice Spot Coaching with today?")}
                </p>
                <div className="practice-lab-coachee__wrapper">
                    <SimulabCoacheeList />
                </div>
            </section>
            <div className="practice-lab-layout__help">
                <CareTeamLink
                    text={t("If you experience any issues with our new feature:")}
                    variant="brand"
                    className="fs-14 m-0"
                />
            </div>
        </ParticipantLayout>
    )
}
